// Keep in sync with app/lib/enums/brand_sku_mapper_enums.py

export const BrandSkuMapperRunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const BrandSkuMapperReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  NO_MATCH: 'NO_MATCH',
};

export const BrandSkuMapperReviewAction = {
  APPROVE: 'approve',
  REJECT: 'reject',
  NO_MATCH: 'no_match',
  PICK: 'pick',
};

// Pre-built tab definitions for the review board status filter.
// Derived from BrandSkuMapperReviewStatus so the keys stay in sync with the backend.
export const BRAND_SKU_MAPPER_REVIEW_STATUS_TABS = [
  { key: '', label: 'All' },
  { key: BrandSkuMapperReviewStatus.PENDING, label: 'Pending' },
  { key: BrandSkuMapperReviewStatus.APPROVED, label: 'Approved' },
  { key: BrandSkuMapperReviewStatus.REJECTED, label: 'Rejected' },
  { key: BrandSkuMapperReviewStatus.NO_MATCH, label: 'No Match' },
];

// Scope filter for the manufacturers landing page.
export const BrandSkuMapperScope = {
  ALL: 'all',
  REBATE: 'rebate',
  ALL_GMV_PRODUCTS: 'all_gmv_products',
};

// Pre-built tab definitions for the manufacturers scope filter.
export const BRAND_SKU_MAPPER_SCOPE_TABS = [
  { key: BrandSkuMapperScope.REBATE, label: 'Influence rebate campaigns' },
  { key: BrandSkuMapperScope.ALL, label: 'All manufacturers' },
  { key: BrandSkuMapperScope.ALL_GMV_PRODUCTS, label: 'All GMV Products' },
];

// Run scope values returned by the backend (mirrors BrandSkuMapperRunScope enum).
export const BrandSkuMapperRunScope = {
  MANUFACTURER: 'MANUFACTURER',
  ALL_GMV_PRODUCTS: 'ALL_GMV_PRODUCTS',
};

// Request body field names for starting a run (mirrors backend BSM run request schema).
export const BrandSkuMapperRunRequestField = {
  REMAINING_ONLY: 'remaining_only',
  USE_VISION: 'use_vision',
};
